import React from 'react';
import {
    Row,
    Col,
} from 'antd';
import ReviewProduct from '../ReviewForm/ReviewProductForm';
import ProductDetailsComponent from '../../ProductDetailsComponent/ProductDetailsComponent';

const ProductDetails = (props) => {

    const childProps = props.props; 

    const onReject = (values) => {
        childProps.rejectProduct({
            "product_id": childProps.id,
            "rejection_details": values.msg,
            "rejection_against_artist": childProps.productReducer.product.assigned_artist,
            "reference_files": values.reference_files
        });
        childProps.updateProduct({
            product_id: childProps.id,
            model_status: "-5"
        });
    }

    const onApprove = () => {
        childProps.updateProduct({
            product_id: childProps.id,
            model_status: "5"
        });
    }
    
    return (
        <div>
            <Row type="flex" justify="space-around" gutter={12}>
                <Col span={24}>
                    <ProductDetailsComponent {...props}  storePage={0}  adminCheck={false} embed={false}/>
                    <Row type="flex" style={{ justifyContent: "space-between", marginTop: "15px" }}>
                        <h3>{childProps.productReducer.product.product_name}</h3>
                        <h4><a onClick={() => window.open('../product_guidelines/' + childProps.id, 'Product Guidelines', "height=600,width=1000")}>Modeling Guidelines</a></h4>
                    </Row>
                    <hr />
                </Col>
            </Row>
            {childProps.productReducer.product.model_status == "4" ? <ReviewProduct adminForm={false} roomDetail={false} roomDetailModal={false} onApprove={onApprove} onReject={onReject} platform={props.roomReducer.room.platform}></ReviewProduct> : ''}
        </div>
    );


}

export default ProductDetails;
